import { Server, Network, Building2, Users } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { IntegrationConsultForm } from "./IntegrationConsultForm";

const integrations = [
  {
    title: "EHR Systems",
    description: "Seamless integration with major Electronic Health Record systems including Epic, Cerner, and Meditech.",
    icon: Server,
    features: ["Real-time data sync", "FHIR compliance", "Secure data transfer"]
  },
  {
    title: "Care Management",
    description: "Connect with existing care management platforms to streamline patient monitoring and care coordination.",
    icon: Network,
    features: ["Workflow automation", "Care plan integration", "Team collaboration"]
  },
  {
    title: "Facility Management",
    description: "Integration with facility management systems for comprehensive patient care and resource allocation.",
    icon: Building2,
    features: ["Resource tracking", "Staff scheduling", "Facility analytics"]
  },
  {
    title: "Staff Portal",
    description: "Unified portal for healthcare staff to access patient data, monitoring tools, and care protocols.",
    icon: Users,
    features: ["Single sign-on", "Role-based access", "Mobile accessibility"]
  }
];

export const EnterpriseIntegration = () => {
  const [showConsultForm, setShowConsultForm] = useState(false);

  return (
    <section className="py-24 bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Enterprise Integration Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Seamlessly integrate Scienza Health with your existing healthcare infrastructure
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {integrations.map((integration, index) => (
            <Card key={index} className="p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-start space-x-4">
                <div className="bg-primary/10 p-3 rounded-lg">
                  <integration.icon className="w-6 h-6 text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold mb-2">{integration.title}</h3>
                  <p className="text-gray-600 mb-4">{integration.description}</p>
                  <ul className="space-y-2">
                    {integration.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                        <span className="w-1.5 h-1.5 bg-primary rounded-full mr-2" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Button 
            size="lg" 
            className="animate-fade-in"
            onClick={() => setShowConsultForm(true)}
          >
            Schedule Integration Consultation
          </Button>
        </div>

        <IntegrationConsultForm 
          open={showConsultForm} 
          onOpenChange={setShowConsultForm}
        />
      </div>
    </section>
  );
};